import styled from 'styled-components';

export default styled.div`
  display: ${props => (props.active ? 'flex' : 'none')};
  flex: 1;
`;
